import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.scanner-license-old';
import * as api from '../../../clients/api';

@Injectable()
export class ApiScannerLicenseOldEffects {

    ScannerLicenseOld$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_SCANNER_LICENSE_OLD),
        mergeMap((x: ac.GetScannerLicenseOldAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getScannerLicenseOld(x.device_id).pipe(
                map((result: any) => {
                    return new ac.GetScannerLicenseOldErfolgreichAction(result, x.device_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetScannerLicenseOldFehlerAction(error, x.device_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenService);
        }
        return this.service;
    }
}
